import script from "./ShopItemSkeletor.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopItemSkeletor.vue?vue&type=script&setup=true&lang=js"

import "./ShopItemSkeletor.vue?vue&type=style&index=0&id=57aea520&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57aea520"]])

export default __exports__